import { doPost, doGet2 } from './common'

/*

*/

export const start = (breakId, stepId, listicleId) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
    listicleId: listicleId,
  }

  return doPost(`/listicle/start`, payload)
}

export const complete = (breakId, stepId, stepSkipped) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
    skipped: stepSkipped,
  }

  return doPost(`/listicle/complete`, payload)
}

export const vote = (listicleId, itemId, voteType) => {
  let payload = {
    listicleId: listicleId,
    itemId: itemId,
    vote: voteType,
  }

  return doPost(`/listicle/vote`, payload)
}

// Standalone vote-tally fetch used by puck-authored listicles, which render
// outside the StepService flow (PuckStep passes no `service`). Uses doGet2 (not
// doGet) so it returns a raw fetch Response and appends listicleId as a query
// string — matching what `service.get('vote', …)` returns, so ListicleStep3 can
// consume both the same way. listicleId is the puck ListicleContainer id.
export const getListicleVotes = listicleId => {
  return doGet2(`/listicle/vote`, { listicleId })
}
